package top.wcpe.allincore.dsl.compiler.semantic

/**
 * 语义作用域。
 *
 * MVP 不区分嵌套作用域（screen 顶层只有 state 与 fun 两类符号），
 * 因此使用单层 LinkedHashSet 即可，保留插入顺序便于后续诊断/调试。
 */
class Scope {
    /** 已声明的 state 字段名集合。 */
    val stateNames: MutableSet<String> = linkedSetOf()

    /** 已声明的 params 打开参数名集合。 */
    val paramNames: MutableSet<String> = linkedSetOf()

    /** 已声明的 derived 派生值名集合。 */
    val derivedNames: MutableSet<String> = linkedSetOf()

    /** 已声明的 animation 名集合。 */
    val animationNames: MutableSet<String> = linkedSetOf()

    /** 已声明的 screen 级 fun 名集合（C4）。 */
    val funNames: MutableSet<String> = linkedSetOf()

    /** screen 级 fun 参数数量，用于校验事件入口必须是无参 fun。 */
    val funParamCounts: MutableMap<String, Int> = linkedMapOf()
}
